import request from "./internal.js";

export const getAdBanner = (params) =>
    request({
        method: 'get',
        url: '/adBanner/getAdBanner',
        stopLoading: true,
        params,
    });